const Logout = () => {
    return (
        <div className='flex flex-col justify-center items-center h-screen w-screen'>
            <h1 className='text-3xl font-bold'>התנתקת בהצלחה</h1>
            <p>נתראה בקרוב :-)</p>
      </div>
    );
}

export default Logout;